<template>
  <div>
    <el-row id="tabBarNav">
      <el-col>
        <el-form :inline="true">
          <el-form-item label="关键字:">
            <el-input
              v-model="filters.keyWord"
              placeholder="请输入名称"
              clearable
              @clear="handleClear"
            ></el-input>
          </el-form-item>
          <el-form-item label="单位名称:">
            <el-input
              v-model="filters.socialUnitName"
              placeholder="请输入名称"
              clearable
              @clear="handleClear"
            ></el-input>
          </el-form-item>
          <el-form-item label="岗位名称:">
            <el-select
              v-model="filters.stationId"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in stationList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="行业名称:">
            <el-select
              v-model="filters.tradeId"
              style="width: 160px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in tradeList"
                :key="item.Id"
                :label="item.Name"
                :value="item.Id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否缴费:">
            <el-select
              v-model="filters.isPayed"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="缴费方式:">
            <el-select
              v-model="filters.payMethod"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options1"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态:">
            <el-select
              v-model="filters.voucherStatus"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options2"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否启用:">
            <el-select
              v-model="filters.isEnable"
              style="width: 120px"
              clearable
              placeholder="请选择"
            >
              <el-option
                v-for="item in options3"
                :key="item.value"
                :label="item.name"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-table
      :data="tableData"
      border
      v-loading="listLoading"
      @current-change="selectCurrentRow"
      @selection-change="handleSelectionChange"
      highlight-current-row
      :header-row-style="{ height: '47px' }"
      style="width: 100%; margin-bottom: 20px"
    >
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
      <el-table-column
        prop=""
        type="index"
        label="序号"
        align="center"
        :index="indexMethod"
        width="60"
      ></el-table-column>
      <el-table-column
        prop="Name"
        label="姓名"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="PhoneNumber"
        label="手机号"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="CardNo"
        label="身份证号"
        align="center"
        min-width="110"
      ></el-table-column>
      <el-table-column
        prop="StationName"
        label="岗位名称"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="TradeName"
        label="行业名称"
        align="center"
        min-width="100"
      ></el-table-column>
      <el-table-column
        prop="UnitName"
        label="单位名称"
        align="center"
        min-width="120"
      ></el-table-column>
      <el-table-column
        prop="OrderTotal"
        label="学费金额（元）"
        align="center"
        min-width="125"
      >
        <template slot-scope="scope">
          {{ (scope.row.OrderTotal / 100).toFixed(2) }}
        </template>
      </el-table-column>
      <el-table-column
        prop="IsPayed"
        label="是否缴费"
        align="center"
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.IsPayed" type="success">已缴费</el-tag>
          <el-tag v-else type="danger">未缴费</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="LearnSource"
        label="缴费方式"
        align="center"
        min-width="90"
        show-overflow-tooltip
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.LearnSource === 0" type="success">APP报名</el-tag>
          <el-tag v-if="scope.row.LearnSource === 1" type="warning">单位协议缴费</el-tag>
          <el-tag v-if="scope.row.LearnSource === 2" type="warning">后台添加</el-tag>
          <el-tag v-if="scope.row.LearnSource === 3" type="warning">APP报名未缴费后,单位协议缴费</el-tag>
          <el-tag v-if="scope.row.LearnSource === 4|| scope.row.LearnSource === 5" type="warning">凭证缴费</el-tag>



        </template>
      </el-table-column>
       <el-table-column
        prop=""
        label="缴费凭证"
        align="center"
        min-width="110"
      >
       <template slot-scope="scope">
          <el-button type="text" @click="openPaymentVoucher(scope.row)">查看</el-button>
        </template>
      </el-table-column>
       <el-table-column
        prop=""
        label="凭证审核"
        align="center"
        min-width="110"
      >
        <template slot-scope="scope">
         
          <span v-if="scope.row.VoucherStatus==2">待审核</span>
          <span v-else-if="scope.row.VoucherStatus==3">审核通过</span>
          <span v-else-if="scope.row.VoucherStatus==4">
            审核驳回
            <div>
              <el-button type="text" size="small" @click="rejectReason(scope.row)">查看</el-button>
            </div>
          </span>
           <span v-else>待提交</span>
        </template>
      </el-table-column>
       <el-table-column
        prop="Name"
        label="学习权利"
        align="center"
        min-width="90"
      >
        <template slot-scope="scope">
          <el-tag v-if="scope.row.IsAllowStudy" type="success">开启</el-tag>
          <el-tag v-else type="danger">关闭</el-tag>
        </template>
      </el-table-column>
      <el-table-column
        prop="CreateTime"
        label="创建时间"
        align="center"
        min-width="110"
      ></el-table-column>
      <el-table-column prop="Name" label="学习记录" align="center" width="90">
        <template slot-scope="scope">
          <el-button type="text" @click="preview(scope.row)">查看</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!--底部工具条-->
    <el-col
      :span="24"
      class="pageBar"
      style="padding-bottom: 22px; margin-top: -12px"
    >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pages.pageIndex"
        :page-sizes="pages.pageArr"
        :page-size="pages.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pages.dataCount"
      >
      </el-pagination>
    </el-col>
    <!-- 新增字典 -->
    <el-dialog
      title="学习记录"
      :visible.sync="viewDialog"
      v-model="viewDialog"
      :close-on-click-modal="false"
      width="70%"
    >
      <div style="margin-top: -20px">
        合格课时：{{
          detailNeedData && detailNeedData.QualifiedLineDuration
            ? detailNeedData.QualifiedLineDuration
            : "0"
        }}
        &nbsp;&nbsp;&nbsp;&nbsp; 学习课时：{{
          detailNeedData
            ? detailNeedData.HandsOnDuration +
              detailNeedData.OffLineDuration +
              detailNeedData.OnlineDuration
            : "0"
        }}
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="视频学习记录" name="0">
          <el-table
            :data="tableDataStudy"
            border
            v-loading="listStudyLoading"
            highlight-current-row
            :header-row-style="{ height: '47px' }"
            style="width: 100%; margin-bottom: 5px"
            :cell-style="rowClass"
          >
            <!-- <el-table-column prop="Code" type="index"  label="序号" align="center"  width="80"></el-table-column> -->
            <el-table-column
              prop="StudyDate"
              label="学习日期"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{
                  scope.row.StudyDate ? scope.row.StudyDate.split(" ")[0] : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="VideoName"
              label="学习视频"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="LearnDuration"
              label="学习时长"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{ formatSeconds(scope.row.LearnDuration) }}
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="pageBar">
            <el-pagination
              @size-change="handleSizeChangeStudy"
              @current-change="handleCurrentChangeStudy"
              :current-page="pagesStudy.pageIndex"
              :page-sizes="pagesStudy.pageArr"
              :page-size="pagesStudy.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagesStudy.dataCount"
            >
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="试题练习记录" name="1">
          <el-table
            :data="tableDataStudy"
            border
            v-loading="listStudyLoading"
            highlight-current-row
            :header-row-style="{ height: '47px' }"
            style="width: 100%; margin-bottom: 5px"
            :cell-style="rowClass"
          >
            <!-- <el-table-column prop="Code" type="index"  label="序号" align="center"  width="80"></el-table-column> -->
            <el-table-column
              prop="StudyDate"
              label="学习日期"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{
                  scope.row.StudyDate ? scope.row.StudyDate.split(" ")[0] : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="TrainCount"
              label="练习题数"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="LearnDuration"
              label="学习时长"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{ formatSeconds(scope.row.LearnDuration) }}
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="pageBar">
            <el-pagination
              @size-change="handleSizeChangeStudy"
              @current-change="handleCurrentChangeStudy"
              :current-page="pagesStudy.pageIndex"
              :page-sizes="pagesStudy.pageArr"
              :page-size="pagesStudy.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagesStudy.dataCount"
            >
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="模拟考试记录" name="2">
          <el-table
            :data="tableDataStudy"
            border
            v-loading="listStudyLoading"
            highlight-current-row
            :header-row-style="{ height: '47px' }"
            style="width: 100%; margin-bottom: 5px"
          >
            <!-- <el-table-column prop="Code" type="index"  label="序号" align="center"  width="80"></el-table-column> -->
            <el-table-column
              prop="StudyDate"
              label="考试日期"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{
                  scope.row.StudyDate ? scope.row.StudyDate.split(" ")[0] : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="ExamName"
              label="试卷名称"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="ExamDuration"
              label="考试用时"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{ formatSeconds(scope.row.ExamDuration) }}
              </template>
            </el-table-column>
            <el-table-column
              prop="TotalScore"
              label="得分"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="isQualified"
              label="是否及格"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                <el-tag v-if="scope.row.IsQualified" type="success"
                  >及格</el-tag
                >
                <el-tag v-else type="danger">不及格</el-tag>
              </template>
            </el-table-column>
            <el-table-column
              prop="QuestionCount"
              label="答题数"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="LearnDuration"
              label="学习时长"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{ formatSeconds(scope.row.LearnDuration) }}
              </template>
            </el-table-column>
          </el-table>
          <el-col :span="24" class="pageBar">
            <el-pagination
              @size-change="handleSizeChangeStudy"
              @current-change="handleCurrentChangeStudy"
              :current-page="pagesStudy.pageIndex"
              :page-sizes="pagesStudy.pageArr"
              :page-size="pagesStudy.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="pagesStudy.dataCount"
            >
            </el-pagination>
          </el-col>
        </el-tab-pane>
        <el-tab-pane label="仿真实操学习记录" name="3">
          <el-table
            :data="FZSCstudyList"
            border
            v-loading="FZSCstudyLoading"
            highlight-current-row
            :header-row-style="{ height: '47px' }"
            style="width: 100%; margin-bottom: 5px"
            :cell-style="rowClass"
          >
            <el-table-column
              prop="StudyDate"
              label="使用	日期"
              align="center"
              width=""
            >
              <template slot-scope="scope">
                {{
                  scope.row.StudyDate ? scope.row.StudyDate.split(" ")[0] : "-"
                }}
              </template>
            </el-table-column>
            <el-table-column
              prop="TypeName"
              label="教学模式"
              align="center"
              width=""
            ></el-table-column>
            <el-table-column
              prop="LearnDuration"
              label="学习时长"
              align="center"
              width=""
            ></el-table-column>
          </el-table>
          <el-col :span="24" class="pageBar">
            <el-pagination
              @size-change="FZSCSizeChange"
              @current-change="FZSCCurrentChange"
              :current-page="FZSCpages.pageIndex"
              :page-sizes="FZSCpages.pageArr"
              :page-size="FZSCpages.pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="FZSCpages.dataCount"
            >
            </el-pagination>
          </el-col>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer" class="dialog-footer">
        <el-button @click="viewDialog = false">取 消</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="'修改' + (needData?.Name || '') + '学员的课程价格'"
      :visible.sync="adjustPriceDialog"
      v-model="adjustPriceDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        :model="Form"
        label-width="100px"
        ref="Form"
        style="max-width: 700px"
        :rules="FormRules"
      >
        <el-form-item label="新价格：" prop="orderTotal">
          <el-input
            v-model="Form.orderTotal"
            style="width: 60%"
            auto-complete="off"
            placeholder="请输入新价格"
          ></el-input>
          <span style="margin-left: 10px">元</span>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="adjustPriceDialog = false">取 消</el-button>
        <el-button type="primary" @click="savePrice">保存</el-button>
      </div>
    </el-dialog>
    <el-dialog
      title="创建人群"
      :visible.sync="CreateAudienceDialog"
      v-model="CreateAudienceDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        :model="Form2"
        label-width="100px"
        ref="Form2"
        style="max-width: 700px"
        :rules="Form2Rules"
      >
        <el-form-item> 查询出人员数量:{{LearnRecordCount}}人 </el-form-item>
        <el-form-item label="人员名称：" prop="groupName">
          <el-input
            v-model="Form2.groupName"
            style="width: 60%"
            auto-complete="off"
            placeholder="请输入人员名称"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="CreateAudienceDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveCreateAudience">保存</el-button>
      </div>
    </el-dialog>

    <!-- 上传凭证弹窗 -->
    <el-dialog
      title="上传凭证"
      :visible.sync="UploadEvidenceDialog"
      v-model="UploadEvidenceDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form
        :model="Form3"
        ref="Form3"
        :rules="Form3Rules"
        style="margin-left:20px"
      >
        <el-form-item>已选择学员名单</el-form-item>
        <el-form-item>
             <el-table
                :data="UploadEvidencetableData"
                border
                v-loading="listLoading"
                @selection-change="handleSelectionChange"
                highlight-current-row
                :header-row-style="{ height: '47px' }"
                style="width: 100%; "
              >
                
                <el-table-column
                  prop="Name"
                  label="姓名"
                  align="center"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="PhoneNumber"
                  label="手机号"
                  align="center"
                  min-width="120"
                ></el-table-column>
                 <el-table-column
                  prop="UnitName"
                  label="工作单位"
                  align="center"
                  min-width="120"
                ></el-table-column>
                <el-table-column
                  prop="StationName"
                  label="岗位名称"
                  align="center"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="TradeName"
                  label="行业名称"
                  align="center"
                  min-width="100"
                ></el-table-column>
                <el-table-column
                  prop="CreateTime"
                  label="报名时间"
                  align="center"
                  min-width="110"
                ></el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item  style="display:flex;justify-content:flex-end;">
            <span style="color:red;">说明:本项目已报名学习未缴费的学员名单</span>
        </el-form-item>
        <el-form-item  prop="voucherUrl" label="上传凭证:">
            <el-upload
                class="upload-demo"
                :action="uploadImagesUrl"
                :headers="headers"
                multiple
                :limit="3"
                :file-list="fileList"
                :on-success="handlefileSuccess"
                :before-upload="beforefileUpload">
                
                <el-button size="small" type="primary">点击上传</el-button>
                <div slot="tip" class="el-upload__tip" style="margin-left:20px;color:red;">说明:可上传的文件类型 png\jpg\pdf</div>
              </el-upload>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="UploadEvidenceDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveUploadEvidence">保存</el-button>
      </div>
    </el-dialog>
     <el-dialog
      title="缴费凭证"
      :visible.sync="PaymentVoucherDialog"
      v-model="PaymentVoucherDialog"
      :close-on-click-modal="false"
      width="40%"
    >
     <el-image style="object-fit: fit;margin-left:20px;" v-for="(item,index) in PaymentVoucherUrl" :key="index" :src="item" :preview-src-list="PaymentVoucherUrl"   />
    </el-dialog>

    <el-dialog
      title="驳回原因"
      :visible.sync="rejectReasonDialog"
      v-model="rejectReasonDialog"
      :close-on-click-modal="false"
      width="40%"
    >

    {{rejectReasonData?.VoucherRemarks}}
     
    </el-dialog>

    <el-dialog
      title="修改该学员的课程"
      :visible.sync="updateCourseDialog"
      v-model="updateCourseDialog"
      :close-on-click-modal="false"
      width="40%"
    >
      <el-form>
        <el-form-item label="岗位分类:">
              <el-select v-model="Form4.stationId" clearable placeholder="请选择岗位分类"  @change="TradeChange">
                <el-option 
                  v-for="item in stationList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
        </el-form-item>
        <el-form-item label="行业分类:" v-if="isShowStation">
              <el-select v-model="Form4.tradeId" clearable placeholder="请选择行业分类">
                <el-option 
                  v-for="item in tradeList"
                  :key="item.Id"
                  :label="item.Name"
                  :value="item.Id"
                >
                </el-option>
              </el-select>
        </el-form-item>
      </el-form>


 
     <span slot="footer" class="dialog-footer">
            <el-button @click="updateCourseDialog = false">取消</el-button>
            <el-button type="primary" @click.native="updateCourseSubmit" :loading="loading">保存</el-button>
      </span>
     
    </el-dialog>
  </div>
</template>
<script>
import Toolbar from "../../components/Toolbar";
import { getButtonList } from "../../promissionRouter";
import {
  changeStudentLearnRight,
  getLearnRecordListPage,
  getStationTradeList,
  getStudyRecordDetail,
  extendEnrollRightTimes,
  getFzscLearnRecordListPage,
  updateOrderInfoTotal,
  exportLearnRecordListPageApi,
  getLearnRecordCountApi,
  addSocialGroupForExamAndEnrollApi,
  uploadImagesUrl,
  addStudentExamEnrollInfoVoucherApi,
  updateStudentExamEnrollInfoVoucherStatusApi,
  updateStationTradeId

} from "../../api/api";
import util from "../../../util/date";
export default {
  components: { Toolbar },
  data() {
    return {
      activeName: "0",
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      pagesStudy: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      pagesQuestion: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      pagesSimulation: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      viewDialog: false,
      detailNeedData: undefined,
      dictionaryList: [],
      filters: {
        stationId: undefined, //岗位ID
        tradeId: undefined, //行业信息ID
        keyWord: undefined, //搜索关键字
        socialUnitName: undefined, //单位名称
        isPayed: undefined, //是否缴费 0:未缴费 1:已缴费
        payMethod: undefined, //缴费方式 0:单位协议缴费 1:App缴费
        isEnableLearnRight: undefined, //是否启用学习权限 0:未启用 1:已启用
        isEnable: undefined,
        voucherStatus:undefined
      },
      stationList: [],
      tradeList: [],
      options3: [
        { value: 1, name: "已启用" },
        { value: 0, name: "未启用" },
      ],
      options: [
        { value: 1, name: "已缴费" },
        { value: 0, name: "未缴费" },
      ],
      options1: [
        { value: 1, name: "单位协议缴费" },
        { value: 0, name: "App缴费" },
        { value: 3, name: "凭证审核" },
        { value: 4, name: "后台免单" }

      ],
      options2: [
        { value: 1, name: "待提交" },
        { value: 2, name: "待审核" },
        { value: 3, name: "审核通过" },
        { value: 4, name: "审核驳回" }

      ],
      buttonList: [],
      tableData: [],
      tableDataStudy: [],
      tableDataQuestion: [],
      tableDataSimulation: [],
      listLoading: false,
      listStudyLoading: false,
      listQuestionLoading: false,
      listSimulationLoading: false,
      needData: "",
      // 仿真实操学习记录
      FZSCstudyLoading: false,
      FZSCstudyList: [],
      FZSCpages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      adjustPriceDialog: false,
      CreateAudienceDialog: false,
      Form: {
        learnRecordId: "",
        orderTotal: "",
      },
      FormRules: {
        orderTotal: [
          { required: true, message: "请输入价格", trigger: "blur" },
        ],
      },
      Form2: {
        groupName: "",
      },
      Form2Rules: {
        groupName: [
          { required: true, message: "请输入人员名称", trigger: "blur" },
        ],
      },
      LearnRecordCount:0,
      studentAccountIdList:[],
      UploadEvidenceDialog:false,
      UploadEvidencetableData:[],
      fileList:[],
      Form3:{
        voucherUrl :"",
        studentExamEnrollIfoIds:[]
      },
      Form3Rules: {
        voucherUrl: [
          { required: true, message: "请上传凭证文件", trigger: "blur" },
        ],
      },
      PaymentVoucherDialog:false,
      PaymentVoucherUrl:[],
      uploadImagesUrl:"",
      rejectReasonDialog:false,
      rejectReasonData:null,
      updateCourseDialog:false,
      Form4:{
        stationId :"",
        tradeId:""
      },
      isShowStation:true

      
    };
  },
  methods: {
    formatSeconds(seconds) {
      const hours = Math.floor(seconds / 3600);
      const minutes = Math.floor((seconds % 3600) / 60);
      const remainingSeconds = seconds % 60;
      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}:${remainingSeconds.toString().padStart(2, "0")}`;
    },
    handleClick(tab, event) {
      if (this.activeName == 3) {
        this.FZSCpages.pageIndex = 1;
        this.getFZSCstudyFun();
      }
    },
    //查看
    preview(row) {
      this.pagesStudy.pageIndex = 1;
      this.pagesStudy.pageSize = 20;
      this.activeName = "0";
      this.detailNeedData = row;
      this.getStudyRecordDetail(row);
      this.viewDialog = true;
    },
    //获取学习记录
    async getStudyRecordDetail(row) {
      let params = {
        studentAccountId: row.StudentAccountId, //学生Id
        pageIndex: this.pagesStudy.pageIndex,
        pageSize: this.pagesStudy.pageSize,
        studentLearnRecordId: row.Id, //报名学习记录id
        searchType: 0, //0:视频学习记录，1:试题练习记录，2:模拟考试记录
      };
      if (this.activeName === "0") {
        params.searchType = 0;
      } else if (this.activeName === "1") {
        params.searchType = 1;
      } else if (this.activeName === "2") {
        params.searchType = 2;
      }
      this.listStudyLoading = true;
      getStudyRecordDetail(params).then((res) => {
        if (res.data.Success) {
          this.tableDataStudy = res.data.Response.Data;
          this.pagesStudy.dataCount = res.data.Response.DataCount;
        }
        this.listStudyLoading = false;
      });
    },
    // 获取仿真实操学习记录
    getFZSCstudyFun() {
      var params = {
        pageIndex: this.FZSCpages.pageIndex,
        pageSize: this.FZSCpages.pageSize,
        studentLearnRecordId: this.detailNeedData.Id,
      };
      this.FZSCstudyLoading = true;
      getFzscLearnRecordListPage(params).then((res) => {
        if (res.data.Success) {
          this.FZSCstudyList = res.data.Response.Data;
          this.FZSCpages.dataCount = res.data.Response.DataCount;
        }
        this.FZSCstudyLoading = false;
      });
    },

    // 获取行业名称
    async getTradeTypeData() {
      let params = {
        dataType: 0,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.tradeList = res.data.Response;
      }
    },
    //获取岗位名称
    async getStationList() {
      let params = {
        dataType: 1,
      };
      const res = await getStationTradeList(params);
      if (res.data.Success) {
        this.stationList = res.data.Response;
      }
    },
    callFunction(item) {
      this[item.Func].apply(this, item);
    },
    // 清除input框，重新获取数据
    handleClear() {
      this.getDataList();
    },
    // 获取分页列表
    getDataList() {
      let params = {
        pageIndex: this.pages.pageIndex, //当前页
        pageSize: this.pages.pageSize, //每页条数
        stationId: this.filters.stationId, //岗位ID
        tradeId: this.filters.tradeId, //行业信息ID
        keyWord: this.filters.keyWord, //搜索关键字
        socialUnitName: this.filters.socialUnitName, //单位名称
        isPayed: this.filters.isPayed, //是否缴费 0:未缴费 1:已缴费
        payMethod: this.filters.payMethod,
        isEnableLearnRight: this.filters.isEnable, //是否启用学习权限 0:未启用 1:已启用
        voucherStatus:this.filters.voucherStatus
      };
      this.listLoading = true;
      getLearnRecordListPage(params).then((res) => {
        let result = res.data;
        if (result.Success) {
          this.tableData = result.Response.Data;
          this.pages.dataCount = result.Response.DataCount;
        } else {
          this.tableData = [];
          this.pages.dataCount = 0;
        }
        this.listLoading = false;
      });
    },
    // 查询
    getListData() {
      this.pages.pageIndex = 1;
      this.pages.pageSize = 20;
      this.getDataList();
    },
    //启用、禁用
    enableOrDisable() {
      if (this.needData) {
        this.$confirm(
          `确定${!this.needData.IsAllowStudy ? "启用" : "禁用"}？`,
          "提示",
          {}
        ).then(() => {
          let params = {
            Id: this.needData.Id,
            IsAllowStudy: !this.needData.IsAllowStudy,
          };
          changeStudentLearnRight(params).then((res) => {
            if (res.data.Success) {
              this.$message({
                type: "success",
                message: res.data.Message,
              });
              this.getListData();
            } else {
              this.$message({
                type: "error",
                message: res.data.Message,
              });
            }
          });
        });
      } else {
        this.$message({
          type: "error",
          message: "请选择一条数据",
        });
      }
    },
    // 延长仿真次数
    extendFZnum() {
      if (this.needData) {
        this.$confirm(`确定延长仿真次数吗？`, "提示", {}).then(() => {
          let params = {
            studentLearnRecordId: this.needData.Id,
          };
          extendEnrollRightTimes(params).then((res) => {
            if (res.data.Success) {
              this.$message({
                type: "success",
                message: res.data.Message,
              });
              this.getListData();
            } else {
              this.$message({
                type: "error",
                message: res.data.Message,
              });
            }
          });
        });
      } else {
        this.$message({
          type: "warning",
          message: "请先选择要延长仿真次数的数据",
        });
      }
    },
    // 点击table某一行
    selectCurrentRow(val) {
      this.needData = val;
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getDataList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getDataList();
    },
    // 分页
    handleCurrentChangeStudy(val) {
      this.pagesStudy.pageIndex = val;
      this.getStudyRecordDetail(this.detailNeedData);
    },
    handleSizeChangeStudy(val) {
      this.pagesStudy.pageSize = val;
      this.getStudyRecordDetail(this.detailNeedData);
    },
    // 分页
    FZSCCurrentChange(val) {
      this.FZSCpages.pageIndex = val;
      this.getFZSCstudyFun();
    },
    FZSCSizeChange(val) {
      this.FZSCpages.pageSize = val;
      this.getFZSCstudyFun();
    },
    //时间格式化
    formatCreateTime: function (row, column) {
      return !row.CreateTime || row.CreateTime == ""
        ? ""
        : util.formatDate.format(new Date(row.CreateTime), "yyyy-MM-dd");
    },
    // 表格数据分页条数累计
    indexMethod(index) {
      let currentPage = this.pages.pageIndex;
      let pageSize = this.pages.pageSize;
      return index + 1 + (currentPage - 1) * pageSize;
    },
    // 表格样式
    rowClass() {
      return "padding: 10px 0!important;";
    },
    // 改价处理方法
    adjustPrice() {
      if (!this.needData) {
        this.$message({
          message: "请选择要改价的学员",
          type: "error",
        });
        return;
      }
      if (this.needData.IsPayed) {
        this.$message({
          message: "课程已缴费，无需改价",
          type: "error",
        });
        return;
      }
      this.Form.orderTotal = "";
      this.$nextTick(() => {
        if (this.$refs.Form) {
          this.$refs.Form.resetFields();
        }
      });

      this.adjustPriceDialog = true;
    },
    savePrice() {
      this.$refs.Form.validate((valid) => {
        if (valid) {
          console.log("valid", valid);
          this.$confirm("确认要保存吗？", "提示", {}).then(() => {
            this.listLoading = true;
            this.Form.learnRecordId = this.needData.Id;
            let params = {
              ...this.Form,
            };
            updateOrderInfoTotal(params).then((res) => {
              if (res.data.Success) {
                this.listLoading = false;
                this.$message({
                  message: res.data.Message,
                  type: "success",
                });
                this.$refs["Form"].resetFields();
                this.adjustPriceDialog = false;
                this.getListData();
              } else {
                this.listLoading = false;
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    saveCreateAudience() {
      this.$refs.Form2.validate((valid) => {
        if (valid) {
          console.log("valid", valid);
          this.$confirm("确定将["+ this.LearnRecordCount + "]人员数量创建人群吗？", "提示", {}).then(() => {
            this.listLoading = true;
            let params = {
              GroupName:this.Form2.groupName,
              Type:1,
              StudentAccountIdList:this.studentAccountIdList,
              FilterCondition:{
                  StationId: this.filters.stationId, //岗位ID
                  TradeId: this.filters.tradeId, //行业信息ID
                  KeyWord: this.filters.keyWord, //搜索关键字
                  SocialUnitName: this.filters.socialUnitName, //单位名称
                  IsPayed: this.filters.isPayed, //是否缴费 0:未缴费 1:已缴费
                  PayMethod: this.filters.payMethod,
                  IsEnableLearnRight: this.filters.isEnable,
                  ProjectId:parseInt(window.localStorage.getItem('projectId'))
              }
              
            };
            addSocialGroupForExamAndEnrollApi(params).then((res) => {
              if (res.data.Success) {
                this.listLoading = false;
                this.$message({
                  message: res.data.Message,
                  type: "success",
                });
                this.$refs["Form2"].resetFields();
                this.CreateAudienceDialog = false;
              } else {
                this.listLoading = false;
                this.$message({
                  message: res.data.Message,
                  type: "error",
                });
              }
            });
          });
        }
      });
    },
    exportExcel() {
      let params = {
        stationId: this.filters.stationId, //岗位ID
        tradeId: this.filters.tradeId, //行业信息ID
        keyWord: this.filters.keyWord, //搜索关键字
        socialUnitName: this.filters.socialUnitName, //单位名称
        isPayed: this.filters.isPayed, //是否缴费 0:未缴费 1:已缴费
        payMethod: this.filters.payMethod, //缴费方式 0:单位协议缴费 1:App缴费
        isEnableLearnRight: this.filters.isEnable, //是否启用学习权限 0:未启用 1:已启用
        voucherStatus:this.filters.voucherStatus
      };
      exportLearnRecordListPageApi(params)
        .then((res) => {
          this.listLoading = false;

          // 2. 检查是否有数据
          if (!res.data || res.data.size === 0) {
            this.$message.error("导出失败：服务器返回数据为空");
            return;
          }

          // 3. 【核心】创建 Blob 对象
          // 明确指定 MIME 类型，这有助于浏览器识别文件
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // 4. 创建下载链接
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // --- 🔥 替换开始：文件名解析逻辑优化 🔥 ---
          let fileName = "学习报名信息.xlsx"; // 默认文件名
          const disposition = res.headers["content-disposition"];
          console.log("disposition", disposition);

          if (disposition) {
            // 1. 优先处理 RFC 5987 标准格式: filename*=UTF-8''xxxxx
            // 这种格式专门用于解决中文文件名乱码问题
            console.log("走这里了");
            const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            console.log("utf8Match", utf8Match);
            if (utf8Match && utf8Match[1]) {
              try {
                // 直接解码 URL 编码的字符串
                fileName = decodeURIComponent(utf8Match[1]);
                console.log("✅ 解析到的文件名 (UTF-8*):", fileName);
              } catch (e) {
                console.error("❌ 文件名解码失败:", e);
                fileName = "学习报名信息.xlsx";
              }
            } else {
              console.log("走这里了222");
              // 2. 备用：处理普通格式 filename="xxxxx" 或 filename=xxxxx
              const normalMatch = disposition.match(/filename="?([^";\n]*)"?/i);
              console.log("normalMatch", normalMatch[1]);
              if (normalMatch && normalMatch[1]) {
                let tempName = normalMatch[1];
                // 尝试解码（防止后端虽然没写 UTF-8* 但实际发了编码后的字符串）
                try {
                  if (tempName.includes("%")) {
                    fileName = decodeURIComponent(tempName);
                  } else {
                    fileName = tempName;
                  }
                } catch (e) {
                  fileName = tempName;
                }
              }
            }
          }

          // 确保后缀名正确
          if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
          }
          // --- 🔥 替换结束 🔥 ---

          link.download = fileName;

          // 6. 触发下载
          document.body.appendChild(link);
          link.click();

          // 7. 清理内存
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.listLoading = false;
          console.error("导出异常:", err);

          // 错误处理：尝试读取错误信息
          if (err.response && err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result);
                this.$message.error(json.message || "导出失败");
              } catch (e) {
                this.$message.error("导出失败：服务器返回非预期数据");
              }
            };
            reader.readAsText(err.response.data);
          } else {
            this.$message.error("网络错误，导出失败");
          }
        });
    },
    CreateAudience() {
      this.Form2.groupName = "";
      this.CreateAudienceDialog = true;
      this.getLearnRecordCountFun();
    },
    getLearnRecordCountFun(){
      let params = {
          stationId: this.filters.stationId, //岗位ID
          tradeId: this.filters.tradeId, //行业信息ID
          keyWord: this.filters.keyWord, //搜索关键字
          socialUnitName: this.filters.socialUnitName, //单位名称
          isPayed: this.filters.isPayed, //是否缴费 0:未缴费 1:已缴费
          payMethod: this.filters.payMethod,
          isEnableLearnRight: this.filters.isEnable,
      }
      getLearnRecordCountApi(params).then(res=>{
          if(res.data.Response){
              this.LearnRecordCount = res.data.Response.Count;
              this.studentAccountIdList = res.data.Response.StudentAcountIdList
          }
      })
    },
    handleSelectionChange(val){
      console.log('val',val)
      this.UploadEvidencetableData = val;
    
    },
    uploadEvidence(){
      this.$nextTick(() => {
        if(this.$refs.Form3) {
          this.$refs.Form3.clearValidate();
        }
      })
      if(this.UploadEvidencetableData.length<=0){
        this.$message.warning("请选择学员!")
        return;
      }
      let isPass = this.UploadEvidencetableData.some(item=>item.VoucherStatus==2 || item.VoucherStatus==3)
      if(isPass){
         this.$message.warning("选择的学员有部分已上传凭证或已审核通过!")
        return;
      }
      this.UploadEvidenceDialog = true
    },
    reviewPassed(){
      if(this.UploadEvidencetableData.length==0){
          this.$message.warning("请选择审核的数据!")
          return;
      }
      let isAllow = this.UploadEvidencetableData.some(item=>item.VoucherStatus==1 || item.VoucherStatus==3 ||  item.VoucherStatus==4  || item.VoucherStatus==null)
      console.log('isAllow',isAllow)
      if(isAllow){
        this.$message.warning("选择的学员部分不为待审核状态!")
        return;
      }
      this.$confirm("确定将以下选择的人员审核通过吗？", "提示", {}).then(() => {
        const idsArr = this.UploadEvidencetableData.map(item=>item.ExamEnrollInfoId)
        let params = {
          studentExamEnrollIfoIds:idsArr.join(','),
          voucherStatus:3
        }
        updateStudentExamEnrollInfoVoucherStatusApi(params).then(res=>{
            if(res.data.Success){
                this.$message.success(res.data.Message)
                this.getDataList()
            }
        })
      })
      
      
    },
     reviewRejectedhandleDel(){
      if(this.UploadEvidencetableData.length==0){
            this.$message.warning("请选择审核驳回的数据!")
            return;
        }
        let isAllow = this.UploadEvidencetableData.some(item=>item.VoucherStatus==1 || item.VoucherStatus==3 || item.VoucherStatus==4 || item.VoucherStatus==null )
        console.log('isAllow',isAllow)
        if(isAllow){
          this.$message.warning("选择的学员部分不为待审核状态!")
          return;
        }
          // 3. 【修改点】使用 $prompt 替代 $confirm，增加输入框和必填校验
        this.$prompt("确定将以下选择的人员审核驳回吗?", "驳回确认", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder: "请填写具体的驳回理由...",
          closeOnClickModal: false, // 可选：防止误触关闭
        })
          .then(({ value }) => {
            // value 即为用户输入的驳回原因
            
            const idsArr = this.UploadEvidencetableData.map(
              (item) => item.ExamEnrollInfoId
            );

            let params = {
              studentExamEnrollIfoIds: idsArr.join(","),
              voucherStatus: 4,
              remark: value
            };

            updateStudentExamEnrollInfoVoucherStatusApi(params).then((res) => {
              if (res.data.Success) {
                this.$message.success(res.data.Message);
                this.getDataList();
              }
            });
          })
          .catch(() => {
            // 用户点击取消或关闭弹窗时的处理（通常不需要做什么）
          });
    },
    handlefileSuccess(res, file,fileList) {
      console.log("fileList",fileList)
      this.Form3.voucherUrl  = fileList.map(item=>item.response.Response.weburl).join(",")
        
    },
    beforefileUpload(file) {
      const allowType = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf'];
      const isAllow = allowType.includes(file.type);
      if (!isAllow) {
        this.$message.error('可上传的文件类型:png、jpg、pdf');
      }
      return isAllow;
    },
    saveUploadEvidence(){
        this.$refs.Form3.validate((valid) => {
          if(valid){
            const idsArr = this.UploadEvidencetableData.map(item=>item.ExamEnrollInfoId)
            this.Form3.studentExamEnrollIfoIds = idsArr.join(',')
            let params  = {
              ...this.Form3
            }
            addStudentExamEnrollInfoVoucherApi(params).then(res=>{
              if(res.data.Success){
                this.$message.success(res.data.Message)
                this.fileList = []
                this.Form3.voucherUrl = ""
                this.UploadEvidenceDialog = false;
                this.getDataList()
          
              }
            })

          }
        })
    },
    openPaymentVoucher(row){
    console.log('row',row.VoucherUrl)
      if(!row.VoucherUrl){
        this.$message.warning("暂无缴费凭证")
      }else{
        this.PaymentVoucherUrl = row.VoucherUrl.split(",")
        console.log(' this.PaymentVoucherUrl', this.PaymentVoucherUrl)
        this.PaymentVoucherDialog = true;
      }
    },
    // 获取token
    getToken() {
      return localStorage.getItem("Token")
    },
    rejectReason(row){
      console.log('row',row)
      this.rejectReasonData = row

      this.rejectReasonDialog = true
    },
    UpdateCourse(){
        console.log('修改课程')
         if(!this.needData){
          this.$message.warning("请选择要修改的数据")
          return;
        }
        console.log('this.needData',this.needData)
        this.Form4.stationId = this.needData.StationId;
        this.Form4.tradeId = this.needData.TradeId==0?'': this.needData.TradeId
          const selectedItem = this.stationList.find(item => item.Id === this.needData.StationId)
          console.log('选中的整行数据1:', selectedItem)
           if(!selectedItem.IsRelation){
              this.isShowStation = false
           }else{
             this.isShowStation = true
           }

      
      
        this.updateCourseDialog = true
    },
    updateCourseSubmit(){
      let params = {
        id:this.needData.Id,
        ...this.Form4

      }
      updateStationTradeId(params).then(res=>{
           if(res.data.Success){
                this.$message.success(res.data.Message)
                this.updateCourseDialog = false
                this.getDataList()
              
               
              }else{
                  this.$message.warning(res.data.Message)
              }
      })

    },
    TradeChange(val){
      console.log('val',val)
       const selectedItem = this.stationList.find(item => item.Id === val)
           console.log('选中的整行数据2:', selectedItem)
           if(!selectedItem.IsRelation){
              this.isShowStation = false
               this.Form4.tradeId = ""
           }else{
             this.isShowStation = true
              this.Form4.tradeId = selectedItem.TradeId
           }

    }
  },
  computed: {
        headers() {
            return{
                "Authorization": 'Bearer ' + this.getToken() // 直接从本地获取token就行
            }
        }
  },
  watch: {
    activeName(val) {
      this.activeName = val;
      this.pagesStudy.pageIndex = 1;
      this.pagesStudy.pageSize = 20;
      if (val != 3) {
        this.getStudyRecordDetail(this.detailNeedData);
      }
    },
  },
  mounted() {
   
    this.getStationList();
    this.getTradeTypeData();
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
    console.log('this.buttonList',this.buttonList)
    this.getListData();
    this.uploadImagesUrl = uploadImagesUrl
      

   
  },
};
</script>
<style lang="stylus" scoped>
.el-textarea>>>.el-textarea__inner {
  min-height: 100px !important;
}

#tabBarNav .el-form-item {
  margin-bottom: 8px;
}
</style>
<style>
.el-tooltip__popper {
  max-width: 500px;
}
</style>